import React from 'react';
import i18n from '../../../../i18n';
import { makeStyles } from '@material-ui/core/styles';

import { Text, TextTypography } from 'components/Text/Text';

const useStyles = makeStyles(theme => ({
    container: {
        textAlign: 'center',
    },
    green: {
        color: '#25da4d',
    },
    red: {
        color: '#EA1103',
    },
    gray: {
        color: 'rgba(36, 49, 67, 0.6)',
    },
}));

export interface PasswordComplexityProps {
    password: string;
}

export const PasswordComplexity = (props: PasswordComplexityProps) => {
    const { t } = i18n.useTranslation();
    const classes = useStyles();
    const { password } = props;

    const checkUpperCase = /(?=.*[A-Z]|[А-ЯЁ])/;
    const checkLowerCase = /(?=.*[a-z]|[а-яё])/;
    const checkDigits = /(?=.*\d)/;
    const upperCaseColor = password !== '' ? (checkUpperCase.test(password) ? 'green' : 'red') : 'gray';
    const lowerCaseColor = password !== '' ? (checkLowerCase.test(password) ? 'green' : 'red') : 'gray';
    const digitsColor = password !== '' ? (checkDigits.test(password) ? 'green' : 'red') : 'gray';

    return (
        <div className={classes.container}>
            <Text typography={TextTypography.PARA}>
                {t('auth:signup.passwordComplexity.eightSigns')},
                <span className={classes[upperCaseColor]}>{t('auth:signup.passwordComplexity.upperCase')}</span>,
                <span className={classes[lowerCaseColor]}>{t('auth:signup.passwordComplexity.lowerCase')}</span>,
                <span className={classes[digitsColor]}>{t('auth:signup.passwordComplexity.digits')}</span>
            </Text>
        </div>
    );
};
